// @flow

import React, { useEffect, useState } from 'react';

import Avatar from '../Avatar';
import { addParamsToUrl } from '@zapier/url-utils';

import { type AvatarProps } from '../Avatar/Avatar';

type Props = {
  ...$Exact<AvatarProps>,
  /** Gravitar URL */
  url: string,
};

/**
 * Gravatar (Avatar) wrapper.
 * Tests is the Gravatar image exists and falls back to name if it doesn't.
 *
 * *Uses the same props as Avatar.*
 */
const Gravatar = (props: Props) => {
  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    let isUrlStillActive = true;
    const urlWith404Fallback = addParamsToUrl(props.url, { d: '404' });
    const testImg = new Image();

    testImg.onload = () => {
      if (isUrlStillActive) {
        setImageUrl(urlWith404Fallback);
      }
    };

    testImg.onerror = () => {
      if (isUrlStillActive) {
        setImageUrl();
      }
    };

    testImg.src = urlWith404Fallback;

    return () => {
      isUrlStillActive = false;
    };
  }, [props.url]);

  return <Avatar {...props} url={imageUrl} />;
};

export default Gravatar;
